import { render } from "./DestinationsComponent.vue?vue&type=template&id=7293dce6"
import script from "./DestinationsComponent.vue?vue&type=script&lang=js"
export * from "./DestinationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__